import { render, staticRenderFns } from "./SortableSongs.vue?vue&type=template&id=1dba79da&"
import script from "./SortableSongs.vue?vue&type=script&lang=js&"
export * from "./SortableSongs.vue?vue&type=script&lang=js&"
import style0 from "./SortableSongs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SortableSongs.vue"
export default component.exports